<template>
    <div class="small-box"
         :class="`bg-${card.theme}`">
        <div class="inner">
            <h3>{{ card.title }}</h3>
            <p> {{ card.subTitle }} </p>
        </div>
        <div class="icon">
            <i :class="card.icon"></i>
        </div>
        <a :href="card.link"
           class="small-box-footer">
            {{ card.linkName }}
            <i class="fas fa-arrow-circle-right ml-1"></i>
        </a>
    </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    props: {
        card: {
            type: Object,
            default() {
                return {

                };
            },
        },

    },
    data() {
        return {
            // weeklyAppointmentsCount: 0, // Set the initial count value
        };
    },
    mounted() {
        // You may need to fetch the data and update the count here
        // For example, using an API call or some other method to get the count
        // and update this.weeklyAppointmentsCount
    },
});

</script>

<style scoped>
.inner h3 {
    padding-top: 11px;
    margin-bottom: 0;
}
</style>
